<template>

  <!-- 弹出向导层 start-->
  <div id="pop" class="pop" v-show="pop_show">
    <span class="pop_bg"></span>
    <div id="pop_bodyup" class="pop_content">
      <!-- 动态查询区生成 -->
      <div class="pop_children">
        <div class="pop_head_close">
          <a class="close" href="javascript:void(0);" @click="closeshow()"></a>
        </div>
        <div>
          <h5>诉讼案例编号{{title}}&nbsp;&nbsp;</h5>
        </div>

        <div class="content_edit">
          <div class="content_edit_item">
            <button class="pre_btn_ok" @click="refresh_data()">
              刷新
            </button>
            <button class="pre_btn_ok" @click="fun_upd('_add')">
              保存
            </button>
            <button class="pre_btn_ok btn_del" @click="fun_upd('_del')">
              删除
            </button>
          </div>
        </div>
        <div class="content_edit">
          <div class="content_edit_item">
            <el-input id="mytextarea" type="textarea" autosize class="mylong" placeholder="请直接输入内容" v-model="longtxt">
            </el-input>
          </div>
        </div>

      </div>

    </div>
  </div>
  <!-- 弹出向导层 end-->


</template>

<script>
  /*
名称：等级划分
日期：2022-03-19
作者：hj
目标：
方法 传入参数，
1、查询标识
2、编辑标识
*/

  import api from '@/utils/type.js';
  import {
    Method_SelColumn,
    Method_ComplexUpdate
  } from '@/utils/loadhttpdata.js';

  import {
    base_decode
  } from "@/utils/base64.js";


  export default {
    name: "pre_mark_tan",
    components: {
      "pre-table": () => import("../auto/auto_view_table.vue"),
    },
    data() {
      return {
        element_loading: false,
        pop_show: false,
        load_url: '',
        load_json: '',
        upd_json: '',
        screenWidth: '',
        screenHeight: '',

        title: '未设置标题',
        sheet_no: '',
        sheet_key: '',
        sel_action: '',
        upd_action: '',
        row_id: '',
        sel_item: [], //备份点击项目
        sys_date: '',

        parm: [], //参数结构
        parm_th: [], //标题
        kw1: '',
        kw2: '',
        kw3: '',

        longtxt: '',
      };
    },
    methods: {
      NextTickName: function(key) {
        // console.log('key=' + key);
        return 'pre' + key;
      },
      checkJson: function(d) {
        let temp = '';
        temp = JSON.stringify(d)
        return temp;
      },
      refresh_view_edit: function(d, type) {
        // console.log(d);
        for (let i = 0; i < this.parm.length; i++) {
          if (this.parm[i].key == d.key) {
            if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
              this.parm[i].val = d.val;
              this.parm[i].sel_name = d.sel_name;
              break;
            } else {
              this.parm[i].val = d.val;
              break;
            }
          }
        }

        if (type == 'save') {
          this.fun_upd('_add');
        }
      },
      showpop: function(parm) {
        this.pop_show = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pop_bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pop_bg").fadeIn("3000");
        $(".pop_content").fadeIn("3000");
        this.load_data(parm)
      },
      closeshow: function() {
        this.pop_show = false;
        $(".pop_bg").fadeOut("3000");
        $(".pop_content").fadeOut("3000");
        this.screenHeight = 0;
        this.screenWidth = 0;
      },
      // refresh_select: function(val) {
      // 	console.log(val);
      // },
      load_data: function(res) {

        // 清理缓存
        this.row_id = '';
        this.sel_action = '';
        this.upd_action = '';

        // console.log(this.pre_data);
        let r = JSON.parse(res);
        console.log('编辑初始化',r);

        this.title = r.title;
        this.sheet_no = r.sheet_no;
        this.sheet_key = r.sheet_key;

        this.sel_action = r.sel_action;
        this.upd_action = r.upd_action;

        this.parm = r.parm;
        this.parm_th = r.parm_th;

        this.longtxt = '';

        this.refresh_data();

      },
      refresh_data: function() {
        // console.log('刷新sheet_no='+this.sheet_no);

        this.element_loading = true;
        let r = (Math.random() + '').substring(0, 8);
        this.$post(
          api.http_method, Method_SelColumn(this.sel_action, this.row_id, this.sheet_no, this.sheet_key, r)
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);

          // console.log(res);
          this.longtxt = (base_decode(res.data));
        });

      },
      fun_upd: function(type) {
        console.log('复杂文本操作类型=' + type);

        let d = [];
        d.push(this.longtxt);
        d.push(this.sheet_no); //主表关键字
        d.push(this.sheet_key);

        let r = (Math.random() + '').substring(0, 8);
        // console.log(d);
        let temp_data = '';
        temp_data = Method_ComplexUpdate('data_' + this.upd_action + type, this.row_id, d, r);

        this.$post(
          api.http_method, temp_data
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });

            this.refresh_data();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });

      }




    }
  };
</script>


<style scoped>
  .mylong {
    max-width: 80vw;
    max-height: 72vh;
  }


  /deep/ .content_edit_item #mytextarea {
    max-width: 80vw;
    max-height: 68vh;
    min-height: 320px !important;
    min-width: 800px;
  }

  .content_edit_item button {
    margin-right: 8px;
  }

  .mark_tab tr td:nth-child(1) {
    display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  }

  /*  .mark_tab tr td:nth-child(3) {
	  display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  	text-align: center;
  } */
</style>
